import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  const tmp = params.productData.map((ele) => {
    const rackInfo = ele.rackInfoList.map((ele2) => {
      return {
        quantity: ele2.quantity,
        rackNumber: commonUtil.nullEmptyFormatNull(ele2.rackNumber)
      }
    })
    ele.rackInfoList = rackInfo
    ele.currencyId = ele.currency.value
    return ele
  })

  return {
    currencyId: params.refundData.currencyId,
    loadingStorageId: params.refundData.storage.value,
    refundDate: params.refundData.refundDate,
    productList: tmp,
    consumptionTax10: String(params.totalList.tax10.tax),
    consumptionTax8: String(params.totalList.tax8.tax),
    adjustAmount: String(params.totalList.adjust),
    note: params.remarks ? params.remarks : null
  }
}
export default { request }
